import axios from 'axios'
import qs from 'qs'
import Cookies from 'js-cookie'
import { ElMessageBox, ElNotification } from 'element-plus'
import useUserStore from '@/stores/User.js'
import { getToken } from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import router from '@/router/index.js'
import Config from '@/utils/Config.js'

// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8;'

// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: Config.baseUrl,

  // 超时
  timeout: 1000000,
})

// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  const token = getToken()

  if (token && !isToken) {
    // 让每个请求携带自定义token 请根据实际情况自行修改
    config.headers.Authorization = `Bearer ${token}`
  }

  if (typeof config.headers['Content-Type'] === 'string' && config.headers['Content-Type'].indexOf('application/x-www-form-urlencoded') > -1 && config.data) {
    config.data = qs.stringify(config.data)
  }

  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = `${config.url}?`

    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName]
      const part = `${encodeURIComponent(propName)}=`

      if (value !== null && typeof value !== 'undefined') {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            const params = `${propName}[${key}]`
            const subPart = `${encodeURIComponent(params)}=`

            url += `${subPart + encodeURIComponent(value[key])}&`
          }
        } else {
          url += `${part + encodeURIComponent(value)}&`
        }
      }
    }
    url = url.slice(0, -1)
    config.params = {}
    config.url = url
  }

  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(async res => {
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200
  // 获取错误信息
  const msg = errorCode[code as keyof typeof errorCode] || res.data.msg || res.data.message || errorCode.default

  if (code === 401) {
    ElMessageBox.alert('Login expired, please log in again', 'Message', {
      confirmButtonText: 'OK',
      type: 'warning',
      callback: () => {
        useUserStore().LogOut()
          .then(() => {
            if (Cookies.get('bOAuth') === 'Y') {
              location.replace(`${(window as any).g.oAuthUrl}${window.location.origin}?${encodeURIComponent(`redirect=${location.hash.substr(1)}`)}`)
            } else {
              window.location.href = '/marketing.html#/ebook'
            }
          })
      },
    })

    return Promise.reject(new Error(msg))
  }

  if (code === 500) {
    // 统一处理接口code为500的msg字段
    ElNotification({
      title: 'Warning',
      message: msg,
      type: 'error',
    })

    return Promise.reject(new Error(msg))
  }
  if (code !== 200) {
    ElNotification({
      title: 'Warning',
      message: msg,
      type: 'error',
    })

    return Promise.reject(Error('error'))
  }

  if (res.config.responseType && res.config.responseType.toLocaleUpperCase() === 'BLOB') {
    if (res.data.type === 'application/json') {
      const blob = new Blob([res.data], {
        type: res.data.type,
      })

      const text = await blob.text()

      try {
        const responseData = JSON.parse(text)

        if (responseData.code === 500) {
          ElNotification({
            title: 'Warning',
            message: responseData.msg,
            type: 'error',
          })

          return Promise.reject(new Error(responseData.msg))
        }
      } catch (err) {
        ElNotification({
          title: '警告',
          message: `Blob Text parsing error JSON.parse(${text})`,
          type: 'error',
        })

        return Promise.reject(Error('Blob Text parsing error'))
      }
    }

    return res
  }

  return res.data
},
error => {
  console.log(`err:${error}`)
  const { message } = error

  ElNotification({
    title: 'warning',
    message,
    type: 'error',
  })

  return Promise.reject(error)
})

export default service

/**
 * 获取URL请求参数
 * @param {String} urlStr URL地址
 * @return {{path:String,params:Object}}  URL解析结果
 */
export function resolveUrl(urlStr: string) {
  const url = urlStr || ''
  const splitIndex = url.indexOf('?')
  const params: Record<string, string> = {}
  let path: string = ''

  if (splitIndex > -1) {
    const hash = url.slice(splitIndex + 1)
      .split('&')

    for (let i = 0; i < hash.length; i++) {
      const h = hash[i].split('=')

      params[h[0]] = h[1]
    }
    path = url.slice(0, splitIndex)
  } else {
    path = url
  }

  return {
    path,
    params,
  }
}
